import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { useTranslation } from "react-i18next";
import "../styles/dashboard.css";
import "../styles/locales.css";

export default function DashboardLayout() {
	const { t, i18n } = useTranslation();
	const [collapsed, setCollapsed] = useState(false);

	// Funzione per cambiare lingua
	const changeLanguage = (lang) => {
		i18n.changeLanguage(lang);
		localStorage.setItem("language", lang);
	};

	// Recupera la lingua salvata
	useEffect(() => {
		const savedLanguage = localStorage.getItem("language") || "it";
		i18n.changeLanguage(savedLanguage);
	}, []);

	return (
		<div className={`dashboard-container ${collapsed ? "collapsed" : ""}`}>
			<Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
			<div className="content">
				<div className="language-switcher">
					<button onClick={() => changeLanguage("it")}>🇮🇹</button>
					<button onClick={() => changeLanguage("en")}>🇬🇧</button>
				</div>
				<h1>{t("welcome")}</h1>

				{/* Qui viene caricato il contenuto della pagina selezionata */}
				<Outlet />
			</div>
		</div>
	);
}
